module.exports = __webpack_public_path__ + "img/movie11.94c088a9.png";